import {BottomDrawerCloseIndicator} from '@frontend/components/BottomDrawerCloseIndicator'
import {trans} from '@frontend/helpers'
import {CommunicationMethodFilter} from '@frontend/modules/public/ads/components/category_filters/filters/CommunicationMethodFilter'
import {PriceFilter} from '@frontend/modules/public/ads/components/category_filters/filters/PriceFilter'
import {useAdCategoryFiltersForm} from '@frontend/modules/public/ads/hooks/useAdCategoryFiltersForm'
import {Button} from 'swayok-react-mdb-ui-kit/components/Button/Button'
import {Card} from 'swayok-react-mdb-ui-kit/components/Card/Card'
import {CardBody} from 'swayok-react-mdb-ui-kit/components/Card/CardBody'
import {CardFooter} from 'swayok-react-mdb-ui-kit/components/Card/CardFooter'
import {ModalBody} from 'swayok-react-mdb-ui-kit/components/Modal/ModalBody'
import {ModalFooter} from 'swayok-react-mdb-ui-kit/components/Modal/ModalFooter'
import {ModalHeader} from 'swayok-react-mdb-ui-kit/components/Modal/ModalHeader'
import {AdCategoryFiltersSubcategoriesNav} from './AdCategoryFiltersSubcategoriesNav'
import {ItemsCategoryPropertyFilters} from './ItemsCategoryPropertyFilters'

interface ItemsCategoryFiltersCardProps {
    forModal?: boolean
    services?: boolean
    onClose?: () => void
}

// Панель фильтрации списка объявлений или исполнителей услуг.
export function ItemsCategoryFiltersCard(props: ItemsCategoryFiltersCardProps) {

    const {
        forModal,
        services,
        onClose,
    } = props

    // Предотвращение спама.
    const {
        isSubmitting,
        onSubmit,
        urlQueryData,
        categoryId,
        filters,
        setFilters,
    } = useAdCategoryFiltersForm(onClose)

    const submitButton = (
        <Button
            color="blue"
            type="submit"
            className="full-width"
            onClick={onSubmit}
            disabled={isSubmitting}
        >
            {trans().ads.list.filters.submit}
        </Button>
    )

    const content = (
        <>
            <AdCategoryFiltersSubcategoriesNav
                categoryId={categoryId}
                services={services}
                urlQueryParams={urlQueryData}
            />
            {!services && (
                <PriceFilter
                    minPrice={filters.minPrice ?? null}
                    maxPrice={filters.maxPrice ?? null}
                    setMinPrice={value => {
                        setFilters(filters => ({
                            ...filters,
                            minPrice: value,
                        }))
                    }}
                    setMaxPrice={value => {
                        setFilters(filters => ({
                            ...filters,
                            maxPrice: value,
                        }))
                    }}
                    disabled={isSubmitting}
                />
            )}
            <ItemsCategoryPropertyFilters
                categoryId={categoryId}
                filters={filters}
                setFilters={setFilters}
                isSubmitting={isSubmitting}
            />
            {!services && (
                <CommunicationMethodFilter
                    value={filters.communicationMethod ?? []}
                    disabled={isSubmitting}
                    onChange={value => {
                        setFilters(filters => ({
                            ...filters,
                            communicationMethod: value,
                        }))
                    }}
                />
            )}
        </>
    )

    if (forModal) {
        return (
            <form
                className="modal-content m-0"
                onSubmit={onSubmit}
            >
                {onClose && <BottomDrawerCloseIndicator onClose={onClose} />}
                <ModalHeader
                    title={trans().ads.list.filters.header}
                    border={false}
                    onClose={onClose}
                >
                    <Button
                        color="gray"
                        outline
                        small
                        className="py-1 px-2 text-nowrap ms-auto"
                        onClick={() => setFilters({})}
                    >
                        {trans().ads.list.filters.reset_filter}
                    </Button>
                </ModalHeader>
                <ModalBody className="pb-0">
                    {content}
                </ModalBody>
                <ModalFooter>
                    {submitButton}
                </ModalFooter>
            </form>
        )
    }

    return (
        <Card
            tag="form"
            onSubmit={onSubmit}
            className="category-filters m-0"
        >
            <CardBody className="pt-3 px-3 pb-0">
                {content}
            </CardBody>
            <CardFooter className="px-3">
                {submitButton}
            </CardFooter>
        </Card>
    )
}
